import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { GlobalCurrentUserService } from "./global-current-user.service";
import { SharedService } from './shared.service';
import { NetworkService } from 'src/app/configuration/network.service';
import { secureStorage } from './secure-storage';
import { API } from 'src/app/configuration/end-points';
import { SpecialService } from 'src/app/configuration/special.service';
import { environment } from 'src/environments/environment';
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root"
})
export class UnauthGuardService implements CanActivate {
  currentUser: any;
  confiObj: any;
  KEY_VAR: any;
  IV_VAR: any;
  /*
  if authenticated
	if auth expiry
		try refresh token api
         if success update localstorage hence show dashboard
		 else /login
    else /dashboard
then else /login
  */
  constructor(
    private router: Router,
    private globalCurrentUserService: GlobalCurrentUserService,
    private specialService: SpecialService,
    private sharedService:SharedService,
    private networkService:NetworkService,
    private cookieService: CookieService
  ) {  }
   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const encr = secureStorage.hash("currentUser");
    this.cookieService.check(encr) && (this.currentUser = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    !this.cookieService.check(encr) && (this.currentUser = null);
    this.sharedService.getConfig().subscribe(result => this.confiObj = result);
    if(!this.confiObj){
      await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);
    }else if(!this.confiObj["username"] ||
    !this.confiObj["MODULE_ID"] ||
    !this.confiObj["RESET_PASS_CALLBACK_LINK"] ||
    !this.confiObj["basicApiHost"] || 
    !this.confiObj["apiHost"] ||
    !this.confiObj["loginUrl"] ||
    !this.confiObj["MODULE_NAME"])
    {
     await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);
    
    }
     // this.sharedService.getConfig().subscribe(result => this.confiObj = result);
    // if (!this.confiObj) {
    //   console.log("Print");
    //   let keys = await this.networkService.getConfigurations(environment.KEYS_FILE_NAME);
    //   this.KEY_VAR = keys["EVO_KEY"];
    //   this.IV_VAR = keys["EVO_IV"];
    //   let configData =await this.networkService.getConfigurations(environment.CONFIG_FILE_NAME);
      
    //   let key = CryptoJS.enc.Utf8.parse(this.KEY_VAR);
    //   let iv = CryptoJS.enc.Utf8.parse(this.IV_VAR);
    //   let decrypted = CryptoJS.AES.decrypt(configData["EvoPortal"]["apiBasicPassword"], key, {
    //     keySize: 128 / 16,
    //     iv: iv,
    //     mode: CryptoJS.mode.CBC,
    //     padding: CryptoJS.pad.Pkcs7
    //   });
    //   let basicAuthPassword =  decrypted.toString(CryptoJS.enc.Utf8);//this.sharedService.decrypt(result["EvoPortal"]["apiBasicPassword"])
    
     
    //   let confiObj = {
    //     basicAuthPassword: basicAuthPassword,
    //     username: configData["EvoPortal"]["apiBasicUsername"],
    //     MODULE_ID: configData["EvoPortal"]["moduleId"],
    //     MODULE_Name: configData["EvoPortal"]["moduleName"],
    //     RESET_PASS_CALLBACK_LINK: configData["EvoPortal"]["callBackLink"],
    //     basicApiHost: configData["EvoPortal"]["apiBasicUrl"],
    //     apiHost: configData["EvoPortal"]["apiUrl"]
    //   }
    //   this.sharedService.updateConfig(confiObj);
    // }

    const url:any = state.url.split('?');
    if(url[0]==='/login'){
      if (this.currentUser) {

        /** to check auth token exired */
    const expiresIn = new Date(this.currentUser.expiresIn);
    const currentDate = new Date();
    if(currentDate > expiresIn){
      
     // console.log("Token Expired");
    let temp:any;
    const response= await this.specialService.refreshToken(temp, API.REFRESH_TOKEN.REFRESH);
    
    if(!response){
      localStorage.clear();
      this.cookieService.deleteAll('/', null , true);
      return true;
    }
    //console.log("Token updated");
    // this.globalCurrentUserService.setCurrentUser(
    //   JSON.stringify({accessToken:response["accessToken"], refreshToken:response["refreshToken"], expiresIn:response["expiresIn"], terrId:response["terrId"]})
    // );
    const currentUser = JSON.parse(this.globalCurrentUserService.getCurrentUser());
          const newCookie = { accessToken: response["accessToken"], refreshToken: response["refreshToken"], expiresIn: response["expiresIn"] };
          this.globalCurrentUserService.setCurrentUser(
            JSON.stringify(Object.assign(currentUser, newCookie))
          );
      }else{
        this.router.navigate(["/layout"]);
      }
    }
  } 

    /**code for non login components */
    if (this.currentUser) {
      this.router.navigate(["/layout"]);
    }else{
    return true;
    }
   }

}
